import { PaymentStudentDTO } from '../../../src_server/entity/dto/PaymentStudentDTO';


import { Payments } from '../../../src_server/entity/generated/Payments';


import { FBStudentRecordDTO } from '../../../src_server/entity/dto/FBStudentRecordDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class PaymentStudentService extends GeneratedBizBase{
  async getMonthlyPaymentStatus(month1Date: string,building_id: string): Promise<Response<PaymentStudentDTO[]>> {
    return super.restCall<Response<PaymentStudentDTO[]>>('post', '/v1/PaymentStudentService/getMonthlyPaymentStatus', arguments);
  }
  async getMonthlyPaymentStatusByUser(month1Date: string,building_id: string,user_id: string): Promise<Response<PaymentStudentDTO>> {
    return super.restCall<Response<PaymentStudentDTO>>('post', '/v1/PaymentStudentService/getMonthlyPaymentStatusByUser', arguments);
  }
  async saveYuuchoPaymentSetting(paramPayment: Payments): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/PaymentStudentService/saveYuuchoPaymentSetting', arguments);
  }
  async getYuuchoPaymentSetting(user_id: string): Promise<Response<Payments>> {
    return super.restCall<Response<Payments>>('get', '/v1/PaymentStudentService/getYuuchoPaymentSetting', arguments);
  }
  async getFBDataByMonth(firstDayOfMonth: string,building: string,selected: string,target_date: string): Promise<Response<FBStudentRecordDTO>> {
    return super.restCall<Response<FBStudentRecordDTO>>('get', '/v1/PaymentStudentService/getFBDataByMonth', arguments);
  }
}
